import { defineStore } from "pinia";
import { ref, computed } from 'vue';

export const useInvalidCardOverlay = defineStore("InvalidCardOverlay", () => {
  /** State **/
  const error_type = ref<string | null>(null);

  /** Getters **/
  const get_error_type = computed(() => error_type.value);
  const showing = computed(() => error_type.value !== null);

  /** Actions **/
  function show(error: string | null = null): void {
    console.log("[invalid-card-overlay.show]: showing invalid card overlay");
    error_type.value = error;
  }

  function hide(): void {
    console.log("[invalid-card-overlay.hide]: hiding invalid card overlay");
    error_type.value = null;
  }

  return { get_error_type, showing, show, hide };
});

// vim: softtabstop=2:shiftwidth=2
